// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.elements-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.elements-modal {
  background: white;
  border-radius: 10px;
  width: min(1280px, 96vw);
  max-height: 92vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
}

.elements-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 16px 24px;
  border-bottom: 1px solid #e8e8e8;
  background: #fafbfc;
}

.elements-modal-header h2 {
  margin: 0;
  font-size: 19px;
  color: #2c3e50;
}

.elements-modal-subtitle {
  margin: 4px 0 0;
  font-size: 13px;
  color: #7f8c8d;
}

.elements-modal-close {
  padding: 7px 16px;
  background: white;
  border: 1px solid #d0d0d0;
  border-radius: 5px;
  cursor: pointer;
  font-size: 13px;
  color: #555;
  transition: all 0.15s;
}

.elements-modal-close:hover {
  background: #f0f0f0;
}

.elements-modal-body {
  padding: 18px 24px;
  overflow-y: auto;
}

.elements-search-pages {
  display: flex;
  gap: 8px;
  margin-bottom: 14px;
}

.elements-page-btn {
  padding: 5px 14px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background: white;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.15s;
}

.elements-page-btn.active {
  background: #3498db;
  color: white;
  border-color: #3498db;
}

.elements-search-loading {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 40px 16px;
  justify-content: center;
  color: #666;
  font-size: 14px;
}

.elements-spinner {
  width: 18px;
  height: 18px;
  border: 3px solid #d5e5f2;
  border-top-color: #3498db;
  border-radius: 50%;
  animation: elements-spin 0.8s linear infinite;
  display: inline-block;
}

.elements-spinner.light {
  border-color: rgba(255, 255, 255, 0.35);
  border-top-color: white;
  width: 14px;
  height: 14px;
  margin-right: 6px;
}

@keyframes elements-spin {
  to { transform: rotate(360deg); }
}

.elements-search-error {
  padding: 12px 16px;
  color: #c0392b;
  background: #fdecea;
  border-radius: 6px;
  font-size: 14px;
  margin-bottom: 12px;
}

/* Workspace: plano + sidebar de prioridad */
.elements-workspace {
  display: flex;
  gap: 18px;
  align-items: flex-start;
}

.elements-search-image-wrap {
  position: relative;
  flex: 1 1;
  min-width: 0;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
}

.elements-search-image-wrap img {
  max-width: 100%;
  display: block;
}

.elements-box {
  position: absolute;
  border: 3px solid;
  cursor: pointer;
  transition: background 0.15s, box-shadow 0.15s;
  border-radius: 2px;
}

.elements-box:hover {
  background: rgba(52, 152, 219, 0.12);
}

.elements-box.selected {
  background: rgba(52, 152, 219, 0.22);
  box-shadow: 0 0 0 3px rgba(44, 62, 80, 0.5);
}

.elements-box-order {
  position: absolute;
  top: -16px;
  left: -16px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #2c3e50;
  color: white;
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);
}

.elements-box-label {
  position: absolute;
  bottom: 100%;
  left: 0;
  color: white;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  white-space: nowrap;
  border-radius: 3px 3px 0 0;
}

/* Sidebar de prioridad */
.elements-sidebar {
  width: 260px;
  flex-shrink: 0;
  background: #f8f9fa;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 16px;
  position: sticky;
  top: 0;
}

.elements-sidebar h4 {
  margin: 0 0 10px;
  font-size: 14px;
  color: #2c3e50;
}

.elements-sidebar-empty {
  font-size: 13px;
  color: #95a5a6;
  line-height: 1.5;
}

.elements-priority-list {
  list-style: none;
  margin: 0 0 14px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.elements-priority-list li {
  display: flex;
  align-items: center;
  gap: 8px;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 7px 10px;
  font-size: 13px;
  color: #34495e;
}

.elements-priority-num {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #2c3e50;
  color: white;
  font-weight: 700;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.elements-priority-dot {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  flex-shrink: 0;
}

.elements-priority-remove {
  margin-left: auto;
  background: none;
  border: none;
  color: #b0b0b0;
  cursor: pointer;
  font-size: 12px;
  padding: 2px 4px;
}

.elements-priority-remove:hover {
  color: #c0392b;
}

.elements-search-btn {
  width: 100%;
  padding: 10px;
  background: #3498db;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
}

.elements-search-btn:hover:not(:disabled) {
  background: #2980b9;
}

.elements-search-btn:disabled {
  background: #b0c4d4;
  cursor: not-allowed;
}

.elements-clear-btn {
  width: 100%;
  margin-top: 8px;
  padding: 8px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  color: #666;
}

/* Resultados */
.elements-search-results {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.elements-results-title {
  margin: 0 0 4px;
  font-size: 15px;
  color: #2c3e50;
  border-top: 1px solid #eee;
  padding-top: 16px;
}

.elements-result-card {
  display: flex;
  gap: 14px;
  padding: 12px;
  border: 1px solid #e4e4e4;
  border-radius: 8px;
  background: white;
  align-items: center;
  transition: box-shadow 0.15s;
}

.elements-result-card:hover {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.elements-result-thumb {
  width: 150px;
  height: 105px;
  object-fit: contain;
  background: #fafafa;
  border: 1px solid #eee;
  border-radius: 4px;
  cursor: zoom-in;
  flex-shrink: 0;
}

.elements-result-thumb.placeholder {
  background: #f0f0f0;
  cursor: default;
}

.elements-result-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.elements-result-name {
  font-weight: 600;
  font-size: 14px;
  color: #2c3e50;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.elements-result-coverage {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.elements-coverage-chip {
  font-size: 12px;
  padding: 2px 9px;
  border-radius: 10px;
  font-weight: 500;
}

.elements-coverage-chip.hit {
  background: #d5f5e3;
  color: #1e8449;
}

.elements-coverage-chip.miss {
  background: #fdecea;
  color: #c0392b;
}

.elements-result-score {
  font-size: 12px;
  color: #7f8c8d;
}

.elements-result-actions {
  display: flex;
  gap: 8px;
  margin-top: 2px;
}

/* Zoom de imagen de resultado */
.elements-zoom-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px;
  cursor: zoom-out;
}

.elements-zoom-overlay img {
  max-width: 95vw;
  max-height: 92vh;
  object-fit: contain;
  background: white;
  border-radius: 4px;
}

.elements-search-loading small {
  color: #95a5a6;
  font-size: 12px;
}

.elements-zoom-stage {
  position: relative;
  display: inline-block;
  max-width: 95vw;
  max-height: 92vh;
}

.elements-zoom-stage img {
  max-width: 95vw;
  max-height: 92vh;
  object-fit: contain;
  background: white;
  border-radius: 4px;
  display: block;
}

.elements-zoom-box {
  position: absolute;
  border: 3px solid #e6194b;
  background: rgba(230, 25, 75, 0.08);
  border-radius: 2px;
}

.elements-zoom-box-label {
  position: absolute;
  top: -26px;
  left: 0;
  background: #e6194b;
  color: white;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 3px;
  white-space: nowrap;
}

/* Overlay a pantalla completa para el análisis abierto desde un resultado */
.elements-analysis-overlay {
  position: fixed;
  inset: 0;
  background: white;
  z-index: 1200;
  overflow-y: auto;
  padding: 16px 24px;
}

.elements-download-error {
  font-size: 12px;
  color: #c0392b;
}

/* Editor de zonas */
.elements-box.draft {
  border: 2px dashed #2c3e50;
  background: rgba(44, 62, 80, 0.08);
  pointer-events: none;
}

.elements-box-delete {
  position: absolute;
  top: -12px;
  right: -12px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: white;
  border: 1px solid #ccc;
  color: #c0392b;
  font-size: 11px;
  cursor: pointer;
  display: none;
  align-items: center;
  justify-content: center;
  z-index: 3;
}

.elements-box:hover .elements-box-delete {
  display: flex;
}

.elements-search-image-wrap {
  -webkit-user-select: none;
          user-select: none;
}

.elements-zones-tools {
  margin-top: 16px;
  border-top: 1px solid #e0e0e0;
  padding-top: 12px;
}

.elements-zones-tools h4 {
  margin: 0 0 8px;
  font-size: 14px;
  color: #2c3e50;
}

.elements-save-btn {
  width: 100%;
  margin-top: 8px;
  padding: 9px;
  background: #27ae60;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.elements-save-btn:disabled {
  background: #a9d5bc;
  cursor: not-allowed;
}

.elements-save-ok {
  display: block;
  margin-top: 8px;
  font-size: 12px;
  color: #1e8449;
}

.elements-save-pending {
  display: block;
  margin-top: 8px;
  font-size: 12px;
  color: #b9770e;
}

/* Modo edición */
.elements-search-image-wrap.editing {
  cursor: crosshair;
  outline: 2px dashed #f39c12;
  outline-offset: 2px;
}

.elements-box.editable {
  cursor: move;
}

.elements-box-resize {
  position: absolute;
  right: -8px;
  bottom: -8px;
  width: 16px;
  height: 16px;
  background: white;
  border: 2px solid #2c3e50;
  border-radius: 3px;
  cursor: nwse-resize;
  z-index: 3;
}

.elements-edit-help {
  margin: 0 0 12px;
  padding-left: 18px;
  font-size: 12px;
  color: #666;
  line-height: 1.7;
}

.elements-zones-tools button + button {
  margin-top: 8px;
}

/* Zoom comparativo: tu plano | resultado */
.elements-zoom-compare {
  display: flex;
  gap: 18px;
  align-items: flex-start;
  max-width: 96vw;
}

.elements-zoom-panel {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  flex: 1 1;
}

.elements-zoom-title {
  color: white;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.elements-zoom-compare .elements-zoom-stage {
  max-width: 46vw;
}

.elements-zoom-compare .elements-zoom-stage img {
  max-width: 46vw;
  max-height: 84vh;
}

.elements-zoom-box.query {
  background: rgba(52, 152, 219, 0.08);
}

/* Paneles gemelos del zoom comparativo: tamaño fijo, imagen contenida y centrada */
.elements-zoom-panel {
  width: 46vw;
  height: 88vh;
}

.elements-zoom-panel-body {
  flex: 1 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 6px;
}

.elements-zoom-compare .elements-zoom-stage img {
  max-width: 44vw;
  max-height: 80vh;
}

/* Filtros de negocio */
.elements-filters-toggle {
  width: 100%;
  background: none;
  border: none;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: #2c3e50;
  cursor: pointer;
  padding: 6px 0;
}

.elements-filters {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 10px;
}

.elements-filters label {
  display: flex;
  flex-direction: column;
  gap: 3px;
  font-size: 12px;
  color: #555;
}

.elements-filters input,
.elements-filters select {
  padding: 6px 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 13px;
}

/* Datos de negocio en tarjetas */
.elements-result-business {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.elements-result-business span {
  font-size: 12px;
  background: #eef4fa;
  color: #2c5175;
  padding: 2px 9px;
  border-radius: 10px;
}

.elements-result-date {
  color: #999;
}

/* Careo IA en el zoom */
.elements-zoom-overlay {
  flex-direction: column;
  gap: 14px;
}

.elements-zoom-diffs {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 900px;
  width: 90vw;
  cursor: default;
}

.elements-zoom-diff-row {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-start;
}

.elements-zoom-diff-text {
  background: white;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 13px;
  line-height: 1.6;
  color: #2c3e50;
  white-space: pre-line;
  width: 100%;
}

.elements-zoom-overlay {
  overflow-y: auto;
}

.elements-zoom-compare .elements-zoom-panel {
  height: 76vh;
}

.elements-zoom-compare .elements-zoom-stage img {
  max-height: 70vh;
}

.elements-zoom-diff-title {
  color: white;
  font-size: 13px;
  font-weight: 600;
}

.elements-zoom-diff-text.loading {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #666;
}

/* ============ Rediseño fullscreen (feedback jefa 2026-07-08) ============ */
.elements-modal-overlay.fullscreen {
  padding: 0;
}

.elements-modal.fullscreen {
  width: 100vw;
  height: 100vh;
  max-height: 100vh;
  border-radius: 0;
}

.elements-modal-header.compact {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 10px 18px;
}

.elements-modal-header.compact h2 {
  font-size: 17px;
  white-space: nowrap;
}

.elements-topbar-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
}

.elements-topbar-btn {
  padding: 7px 14px;
  border: 1px solid #d0d0d0;
  border-radius: 5px;
  background: white;
  color: #444;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}

.elements-topbar-btn:hover:not(:disabled) {
  background: #f0f0f0;
}

.elements-topbar-btn.primary {
  background: #3498db;
  border-color: #3498db;
  color: white;
  font-weight: 600;
}

.elements-topbar-btn.primary:hover:not(:disabled) {
  background: #2980b9;
}

.elements-topbar-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.elements-filters-bar {
  display: flex;
  gap: 16px;
  align-items: flex-end;
  padding: 10px 18px;
  border-bottom: 1px solid #eee;
  background: #fafbfc;
}

.elements-filters-bar label {
  display: flex;
  flex-direction: column;
  gap: 3px;
  font-size: 12px;
  color: #555;
}

.elements-filters-bar input,
.elements-filters-bar select {
  padding: 5px 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 13px;
}

.elements-save-ok.bar {
  display: block;
  padding: 6px 18px;
  background: #d5f5e3;
  margin: 0;
}

.elements-fullscreen-body {
  flex: 1 1;
  min-height: 0;
  display: flex;
  gap: 0;
}

.elements-image-area {
  flex: 1 1;
  min-width: 0;
  overflow: auto;
  padding: 14px 18px;
}

.elements-results-panel {
  width: 430px;
  flex-shrink: 0;
  border-left: 1px solid #e8e8e8;
  overflow-y: auto;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: #fafbfc;
}

.elements-results-panel .elements-results-title {
  border-top: none;
  padding-top: 0;
}

.elements-results-panel .elements-result-card {
  flex-direction: column;
  align-items: stretch;
}

.elements-results-panel .elements-result-thumb {
  width: 100%;
  height: 150px;
}

.elements-results-panel .elements-results-title + .elements-results-title,
.elements-results-panel ol + .elements-results-title {
  margin-top: 14px;
  border-top: 1px solid #eee;
  padding-top: 14px;
}

/* ============ Criba con IA de los resultados ============ */
/* Va al final a propósito: en CSS el orden pesa tanto como la especificidad y estas reglas
   tienen que poder ganarle a la tarjeta base definida más arriba. */

.elements-screening {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px dashed #d8dde3;
  border-radius: 8px;
  background: #fbfcfd;
  color: #5a6672;
  font-size: 13px;
}

.elements-results-panel .elements-result-card {
  position: relative;
  overflow: hidden;
  /* El panel es un flex en columna: sin esto las tarjetas se encogen para caber todas en vez de
     dejar que el panel ruede, y con muchos resultados se quedan en una tira de 26 px. Antes no
     se notaba porque el contenido se salía a la vista; con overflow:hidden se recorta. */
  flex-shrink: 0;
}

.elements-verdict {
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
  /* se come el padding de la tarjeta para ir de borde a borde, en vez de quitárselo a la
     tarjeta: si no, los resultados que aún no tienen veredicto salen con la miniatura pegada */
  margin: -12px -12px 10px;
  padding: 7px 12px;
  font-size: 12px;
  line-height: 1.45;
  border-bottom: 1px solid transparent;
}

.elements-verdict-label {
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  font-size: 11px;
  white-space: nowrap;
}

.elements-verdict-reason { color: #4b5563; }

.elements-verdict.veredicto-si {
  background: #eaf7f0;
  border-bottom-color: #c7e8d6;
}
.elements-verdict.veredicto-si .elements-verdict-label { color: #1e7e4f; }

.elements-verdict.veredicto-duda {
  background: #fff7e6;
  border-bottom-color: #f3e2bd;
}
.elements-verdict.veredicto-duda .elements-verdict-label { color: #9a6b00; }

.elements-verdict.veredicto-no {
  background: #f4f5f7;
  border-bottom-color: #e2e5e9;
}
.elements-verdict.veredicto-no .elements-verdict-label { color: #6b7280; }

.elements-results-panel .elements-result-card.veredicto-si { border-color: #c7e8d6; }
.elements-results-panel .elements-result-card.veredicto-duda { border-color: #f3e2bd; }
.elements-results-panel .elements-result-card.veredicto-no { opacity: 0.6; }
.elements-results-panel .elements-result-card.veredicto-no:hover { opacity: 1; }

/* Cuando la criba los tumba a todos: decirlo y explicar por qué */
.elements-no-matches {
  border: 1px solid #e4e4e4;
  border-left: 3px solid #9a6b00;
  border-radius: 8px;
  background: white;
  padding: 14px 16px;
}

.elements-no-matches-title {
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
}

.elements-no-matches p {
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
  color: #4b5563;
}

/* El careo del zoom, por renglones en vez de un párrafo pegado */
.elements-diff-row {
  display: flex;
  gap: 10px;
  padding: 5px 0;
  align-items: baseline;
}

.elements-diff-row + .elements-diff-row { border-top: 1px solid #f0f1f3; }

.elements-diff-campo {
  flex: 0 0 76px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #8a94a0;
}

.elements-diff-row.campo-coincide .elements-diff-campo { color: #1e7e4f; }
.elements-diff-row.campo-difiere .elements-diff-campo { color: #9a6b00; }
.elements-diff-row.campo-veredicto .elements-diff-campo { color: #2c3e50; }

.elements-diff-valor { flex: 1 1; }

@media (max-width: 760px) {
  .elements-diff-row { flex-direction: column; gap: 2px; }
  .elements-diff-campo { flex: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Search/ElementsSearchPanel.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;EACvC,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,4EAA4E;AAC5E;EACE,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,mFAAmF;AACnF;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA,6EAA6E;AAC7E;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,MAAM;AACR;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA,6DAA6D;AAC7D;oEACoE;;AAEpE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB;;yFAEuF;EACvF,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf;+FAC6F;EAC7F,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA,2BAA2B,cAAc,EAAE;;AAE3C;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;AACA,yDAAyD,cAAc,EAAE;;AAEzE;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;AACA,2DAA2D,cAAc,EAAE;;AAE3E;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;AACA,yDAAyD,cAAc,EAAE;;AAEzE,6DAA6D,qBAAqB,EAAE;AACpF,+DAA+D,qBAAqB,EAAE;AACtF,6DAA6D,YAAY,EAAE;AAC3E,mEAAmE,UAAU,EAAE;;AAE/E,kEAAkE;AAClE;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,qBAAqB;AACvB;;AAEA,0CAA0C,6BAA6B,EAAE;;AAEzE;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,yDAAyD,cAAc,EAAE;AACzE,wDAAwD,cAAc,EAAE;AACxE,0DAA0D,cAAc,EAAE;;AAE1E,uBAAuB,SAAO,EAAE;;AAEhC;EACE,qBAAqB,sBAAsB,EAAE,QAAQ,EAAE;EACvD,uBAAuB,UAAU,EAAE;AACrC","sourcesContent":[".elements-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n}\n\n.elements-modal {\n  background: white;\n  border-radius: 10px;\n  width: min(1280px, 96vw);\n  max-height: 92vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);\n}\n\n.elements-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 16px 24px;\n  border-bottom: 1px solid #e8e8e8;\n  background: #fafbfc;\n}\n\n.elements-modal-header h2 {\n  margin: 0;\n  font-size: 19px;\n  color: #2c3e50;\n}\n\n.elements-modal-subtitle {\n  margin: 4px 0 0;\n  font-size: 13px;\n  color: #7f8c8d;\n}\n\n.elements-modal-close {\n  padding: 7px 16px;\n  background: white;\n  border: 1px solid #d0d0d0;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 13px;\n  color: #555;\n  transition: all 0.15s;\n}\n\n.elements-modal-close:hover {\n  background: #f0f0f0;\n}\n\n.elements-modal-body {\n  padding: 18px 24px;\n  overflow-y: auto;\n}\n\n.elements-search-pages {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 14px;\n}\n\n.elements-page-btn {\n  padding: 5px 14px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  background: white;\n  cursor: pointer;\n  font-size: 13px;\n  transition: all 0.15s;\n}\n\n.elements-page-btn.active {\n  background: #3498db;\n  color: white;\n  border-color: #3498db;\n}\n\n.elements-search-loading {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 40px 16px;\n  justify-content: center;\n  color: #666;\n  font-size: 14px;\n}\n\n.elements-spinner {\n  width: 18px;\n  height: 18px;\n  border: 3px solid #d5e5f2;\n  border-top-color: #3498db;\n  border-radius: 50%;\n  animation: elements-spin 0.8s linear infinite;\n  display: inline-block;\n}\n\n.elements-spinner.light {\n  border-color: rgba(255, 255, 255, 0.35);\n  border-top-color: white;\n  width: 14px;\n  height: 14px;\n  margin-right: 6px;\n}\n\n@keyframes elements-spin {\n  to { transform: rotate(360deg); }\n}\n\n.elements-search-error {\n  padding: 12px 16px;\n  color: #c0392b;\n  background: #fdecea;\n  border-radius: 6px;\n  font-size: 14px;\n  margin-bottom: 12px;\n}\n\n/* Workspace: plano + sidebar de prioridad */\n.elements-workspace {\n  display: flex;\n  gap: 18px;\n  align-items: flex-start;\n}\n\n.elements-search-image-wrap {\n  position: relative;\n  flex: 1;\n  min-width: 0;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.elements-search-image-wrap img {\n  max-width: 100%;\n  display: block;\n}\n\n.elements-box {\n  position: absolute;\n  border: 3px solid;\n  cursor: pointer;\n  transition: background 0.15s, box-shadow 0.15s;\n  border-radius: 2px;\n}\n\n.elements-box:hover {\n  background: rgba(52, 152, 219, 0.12);\n}\n\n.elements-box.selected {\n  background: rgba(52, 152, 219, 0.22);\n  box-shadow: 0 0 0 3px rgba(44, 62, 80, 0.5);\n}\n\n.elements-box-order {\n  position: absolute;\n  top: -16px;\n  left: -16px;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: #2c3e50;\n  color: white;\n  font-weight: 700;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);\n}\n\n.elements-box-label {\n  position: absolute;\n  bottom: 100%;\n  left: 0;\n  color: white;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 8px;\n  white-space: nowrap;\n  border-radius: 3px 3px 0 0;\n}\n\n/* Sidebar de prioridad */\n.elements-sidebar {\n  width: 260px;\n  flex-shrink: 0;\n  background: #f8f9fa;\n  border: 1px solid #e8e8e8;\n  border-radius: 8px;\n  padding: 16px;\n  position: sticky;\n  top: 0;\n}\n\n.elements-sidebar h4 {\n  margin: 0 0 10px;\n  font-size: 14px;\n  color: #2c3e50;\n}\n\n.elements-sidebar-empty {\n  font-size: 13px;\n  color: #95a5a6;\n  line-height: 1.5;\n}\n\n.elements-priority-list {\n  list-style: none;\n  margin: 0 0 14px;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.elements-priority-list li {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  padding: 7px 10px;\n  font-size: 13px;\n  color: #34495e;\n}\n\n.elements-priority-num {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #2c3e50;\n  color: white;\n  font-weight: 700;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.elements-priority-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n  flex-shrink: 0;\n}\n\n.elements-priority-remove {\n  margin-left: auto;\n  background: none;\n  border: none;\n  color: #b0b0b0;\n  cursor: pointer;\n  font-size: 12px;\n  padding: 2px 4px;\n}\n\n.elements-priority-remove:hover {\n  color: #c0392b;\n}\n\n.elements-search-btn {\n  width: 100%;\n  padding: 10px;\n  background: #3498db;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s;\n}\n\n.elements-search-btn:hover:not(:disabled) {\n  background: #2980b9;\n}\n\n.elements-search-btn:disabled {\n  background: #b0c4d4;\n  cursor: not-allowed;\n}\n\n.elements-clear-btn {\n  width: 100%;\n  margin-top: 8px;\n  padding: 8px;\n  background: white;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 13px;\n  cursor: pointer;\n  color: #666;\n}\n\n/* Resultados */\n.elements-search-results {\n  margin-top: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.elements-results-title {\n  margin: 0 0 4px;\n  font-size: 15px;\n  color: #2c3e50;\n  border-top: 1px solid #eee;\n  padding-top: 16px;\n}\n\n.elements-result-card {\n  display: flex;\n  gap: 14px;\n  padding: 12px;\n  border: 1px solid #e4e4e4;\n  border-radius: 8px;\n  background: white;\n  align-items: center;\n  transition: box-shadow 0.15s;\n}\n\n.elements-result-card:hover {\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);\n}\n\n.elements-result-thumb {\n  width: 150px;\n  height: 105px;\n  object-fit: contain;\n  background: #fafafa;\n  border: 1px solid #eee;\n  border-radius: 4px;\n  cursor: zoom-in;\n  flex-shrink: 0;\n}\n\n.elements-result-thumb.placeholder {\n  background: #f0f0f0;\n  cursor: default;\n}\n\n.elements-result-info {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.elements-result-name {\n  font-weight: 600;\n  font-size: 14px;\n  color: #2c3e50;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.elements-result-coverage {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.elements-coverage-chip {\n  font-size: 12px;\n  padding: 2px 9px;\n  border-radius: 10px;\n  font-weight: 500;\n}\n\n.elements-coverage-chip.hit {\n  background: #d5f5e3;\n  color: #1e8449;\n}\n\n.elements-coverage-chip.miss {\n  background: #fdecea;\n  color: #c0392b;\n}\n\n.elements-result-score {\n  font-size: 12px;\n  color: #7f8c8d;\n}\n\n.elements-result-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 2px;\n}\n\n/* Zoom de imagen de resultado */\n.elements-zoom-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.85);\n  z-index: 1100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 30px;\n  cursor: zoom-out;\n}\n\n.elements-zoom-overlay img {\n  max-width: 95vw;\n  max-height: 92vh;\n  object-fit: contain;\n  background: white;\n  border-radius: 4px;\n}\n\n.elements-search-loading small {\n  color: #95a5a6;\n  font-size: 12px;\n}\n\n.elements-zoom-stage {\n  position: relative;\n  display: inline-block;\n  max-width: 95vw;\n  max-height: 92vh;\n}\n\n.elements-zoom-stage img {\n  max-width: 95vw;\n  max-height: 92vh;\n  object-fit: contain;\n  background: white;\n  border-radius: 4px;\n  display: block;\n}\n\n.elements-zoom-box {\n  position: absolute;\n  border: 3px solid #e6194b;\n  background: rgba(230, 25, 75, 0.08);\n  border-radius: 2px;\n}\n\n.elements-zoom-box-label {\n  position: absolute;\n  top: -26px;\n  left: 0;\n  background: #e6194b;\n  color: white;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 3px;\n  white-space: nowrap;\n}\n\n/* Overlay a pantalla completa para el análisis abierto desde un resultado */\n.elements-analysis-overlay {\n  position: fixed;\n  inset: 0;\n  background: white;\n  z-index: 1200;\n  overflow-y: auto;\n  padding: 16px 24px;\n}\n\n.elements-download-error {\n  font-size: 12px;\n  color: #c0392b;\n}\n\n/* Editor de zonas */\n.elements-box.draft {\n  border: 2px dashed #2c3e50;\n  background: rgba(44, 62, 80, 0.08);\n  pointer-events: none;\n}\n\n.elements-box-delete {\n  position: absolute;\n  top: -12px;\n  right: -12px;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: white;\n  border: 1px solid #ccc;\n  color: #c0392b;\n  font-size: 11px;\n  cursor: pointer;\n  display: none;\n  align-items: center;\n  justify-content: center;\n  z-index: 3;\n}\n\n.elements-box:hover .elements-box-delete {\n  display: flex;\n}\n\n.elements-search-image-wrap {\n  user-select: none;\n}\n\n.elements-zones-tools {\n  margin-top: 16px;\n  border-top: 1px solid #e0e0e0;\n  padding-top: 12px;\n}\n\n.elements-zones-tools h4 {\n  margin: 0 0 8px;\n  font-size: 14px;\n  color: #2c3e50;\n}\n\n.elements-save-btn {\n  width: 100%;\n  margin-top: 8px;\n  padding: 9px;\n  background: #27ae60;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.elements-save-btn:disabled {\n  background: #a9d5bc;\n  cursor: not-allowed;\n}\n\n.elements-save-ok {\n  display: block;\n  margin-top: 8px;\n  font-size: 12px;\n  color: #1e8449;\n}\n\n.elements-save-pending {\n  display: block;\n  margin-top: 8px;\n  font-size: 12px;\n  color: #b9770e;\n}\n\n/* Modo edición */\n.elements-search-image-wrap.editing {\n  cursor: crosshair;\n  outline: 2px dashed #f39c12;\n  outline-offset: 2px;\n}\n\n.elements-box.editable {\n  cursor: move;\n}\n\n.elements-box-resize {\n  position: absolute;\n  right: -8px;\n  bottom: -8px;\n  width: 16px;\n  height: 16px;\n  background: white;\n  border: 2px solid #2c3e50;\n  border-radius: 3px;\n  cursor: nwse-resize;\n  z-index: 3;\n}\n\n.elements-edit-help {\n  margin: 0 0 12px;\n  padding-left: 18px;\n  font-size: 12px;\n  color: #666;\n  line-height: 1.7;\n}\n\n.elements-zones-tools button + button {\n  margin-top: 8px;\n}\n\n/* Zoom comparativo: tu plano | resultado */\n.elements-zoom-compare {\n  display: flex;\n  gap: 18px;\n  align-items: flex-start;\n  max-width: 96vw;\n}\n\n.elements-zoom-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n  flex: 1;\n}\n\n.elements-zoom-title {\n  color: white;\n  font-size: 14px;\n  font-weight: 600;\n  text-align: center;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.elements-zoom-compare .elements-zoom-stage {\n  max-width: 46vw;\n}\n\n.elements-zoom-compare .elements-zoom-stage img {\n  max-width: 46vw;\n  max-height: 84vh;\n}\n\n.elements-zoom-box.query {\n  background: rgba(52, 152, 219, 0.08);\n}\n\n/* Paneles gemelos del zoom comparativo: tamaño fijo, imagen contenida y centrada */\n.elements-zoom-panel {\n  width: 46vw;\n  height: 88vh;\n}\n\n.elements-zoom-panel-body {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.06);\n  border-radius: 6px;\n}\n\n.elements-zoom-compare .elements-zoom-stage img {\n  max-width: 44vw;\n  max-height: 80vh;\n}\n\n/* Filtros de negocio */\n.elements-filters-toggle {\n  width: 100%;\n  background: none;\n  border: none;\n  text-align: left;\n  font-size: 13px;\n  font-weight: 600;\n  color: #2c3e50;\n  cursor: pointer;\n  padding: 6px 0;\n}\n\n.elements-filters {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.elements-filters label {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  font-size: 12px;\n  color: #555;\n}\n\n.elements-filters input,\n.elements-filters select {\n  padding: 6px 8px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 13px;\n}\n\n/* Datos de negocio en tarjetas */\n.elements-result-business {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.elements-result-business span {\n  font-size: 12px;\n  background: #eef4fa;\n  color: #2c5175;\n  padding: 2px 9px;\n  border-radius: 10px;\n}\n\n.elements-result-date {\n  color: #999;\n}\n\n/* Careo IA en el zoom */\n.elements-zoom-overlay {\n  flex-direction: column;\n  gap: 14px;\n}\n\n.elements-zoom-diffs {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-width: 900px;\n  width: 90vw;\n  cursor: default;\n}\n\n.elements-zoom-diff-row {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  align-items: flex-start;\n}\n\n.elements-zoom-diff-text {\n  background: white;\n  border-radius: 8px;\n  padding: 12px 16px;\n  font-size: 13px;\n  line-height: 1.6;\n  color: #2c3e50;\n  white-space: pre-line;\n  width: 100%;\n}\n\n.elements-zoom-overlay {\n  overflow-y: auto;\n}\n\n.elements-zoom-compare .elements-zoom-panel {\n  height: 76vh;\n}\n\n.elements-zoom-compare .elements-zoom-stage img {\n  max-height: 70vh;\n}\n\n.elements-zoom-diff-title {\n  color: white;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.elements-zoom-diff-text.loading {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #666;\n}\n\n/* ============ Rediseño fullscreen (feedback jefa 2026-07-08) ============ */\n.elements-modal-overlay.fullscreen {\n  padding: 0;\n}\n\n.elements-modal.fullscreen {\n  width: 100vw;\n  height: 100vh;\n  max-height: 100vh;\n  border-radius: 0;\n}\n\n.elements-modal-header.compact {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 10px 18px;\n}\n\n.elements-modal-header.compact h2 {\n  font-size: 17px;\n  white-space: nowrap;\n}\n\n.elements-topbar-actions {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.elements-topbar-btn {\n  padding: 7px 14px;\n  border: 1px solid #d0d0d0;\n  border-radius: 5px;\n  background: white;\n  color: #444;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.15s;\n  white-space: nowrap;\n}\n\n.elements-topbar-btn:hover:not(:disabled) {\n  background: #f0f0f0;\n}\n\n.elements-topbar-btn.primary {\n  background: #3498db;\n  border-color: #3498db;\n  color: white;\n  font-weight: 600;\n}\n\n.elements-topbar-btn.primary:hover:not(:disabled) {\n  background: #2980b9;\n}\n\n.elements-topbar-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.elements-filters-bar {\n  display: flex;\n  gap: 16px;\n  align-items: flex-end;\n  padding: 10px 18px;\n  border-bottom: 1px solid #eee;\n  background: #fafbfc;\n}\n\n.elements-filters-bar label {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  font-size: 12px;\n  color: #555;\n}\n\n.elements-filters-bar input,\n.elements-filters-bar select {\n  padding: 5px 8px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 13px;\n}\n\n.elements-save-ok.bar {\n  display: block;\n  padding: 6px 18px;\n  background: #d5f5e3;\n  margin: 0;\n}\n\n.elements-fullscreen-body {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  gap: 0;\n}\n\n.elements-image-area {\n  flex: 1;\n  min-width: 0;\n  overflow: auto;\n  padding: 14px 18px;\n}\n\n.elements-results-panel {\n  width: 430px;\n  flex-shrink: 0;\n  border-left: 1px solid #e8e8e8;\n  overflow-y: auto;\n  padding: 14px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  background: #fafbfc;\n}\n\n.elements-results-panel .elements-results-title {\n  border-top: none;\n  padding-top: 0;\n}\n\n.elements-results-panel .elements-result-card {\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.elements-results-panel .elements-result-thumb {\n  width: 100%;\n  height: 150px;\n}\n\n.elements-results-panel .elements-results-title + .elements-results-title,\n.elements-results-panel ol + .elements-results-title {\n  margin-top: 14px;\n  border-top: 1px solid #eee;\n  padding-top: 14px;\n}\n\n/* ============ Criba con IA de los resultados ============ */\n/* Va al final a propósito: en CSS el orden pesa tanto como la especificidad y estas reglas\n   tienen que poder ganarle a la tarjeta base definida más arriba. */\n\n.elements-screening {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border: 1px dashed #d8dde3;\n  border-radius: 8px;\n  background: #fbfcfd;\n  color: #5a6672;\n  font-size: 13px;\n}\n\n.elements-results-panel .elements-result-card {\n  position: relative;\n  overflow: hidden;\n  /* El panel es un flex en columna: sin esto las tarjetas se encogen para caber todas en vez de\n     dejar que el panel ruede, y con muchos resultados se quedan en una tira de 26 px. Antes no\n     se notaba porque el contenido se salía a la vista; con overflow:hidden se recorta. */\n  flex-shrink: 0;\n}\n\n.elements-verdict {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  flex-wrap: wrap;\n  /* se come el padding de la tarjeta para ir de borde a borde, en vez de quitárselo a la\n     tarjeta: si no, los resultados que aún no tienen veredicto salen con la miniatura pegada */\n  margin: -12px -12px 10px;\n  padding: 7px 12px;\n  font-size: 12px;\n  line-height: 1.45;\n  border-bottom: 1px solid transparent;\n}\n\n.elements-verdict-label {\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  font-size: 11px;\n  white-space: nowrap;\n}\n\n.elements-verdict-reason { color: #4b5563; }\n\n.elements-verdict.veredicto-si {\n  background: #eaf7f0;\n  border-bottom-color: #c7e8d6;\n}\n.elements-verdict.veredicto-si .elements-verdict-label { color: #1e7e4f; }\n\n.elements-verdict.veredicto-duda {\n  background: #fff7e6;\n  border-bottom-color: #f3e2bd;\n}\n.elements-verdict.veredicto-duda .elements-verdict-label { color: #9a6b00; }\n\n.elements-verdict.veredicto-no {\n  background: #f4f5f7;\n  border-bottom-color: #e2e5e9;\n}\n.elements-verdict.veredicto-no .elements-verdict-label { color: #6b7280; }\n\n.elements-results-panel .elements-result-card.veredicto-si { border-color: #c7e8d6; }\n.elements-results-panel .elements-result-card.veredicto-duda { border-color: #f3e2bd; }\n.elements-results-panel .elements-result-card.veredicto-no { opacity: 0.6; }\n.elements-results-panel .elements-result-card.veredicto-no:hover { opacity: 1; }\n\n/* Cuando la criba los tumba a todos: decirlo y explicar por qué */\n.elements-no-matches {\n  border: 1px solid #e4e4e4;\n  border-left: 3px solid #9a6b00;\n  border-radius: 8px;\n  background: white;\n  padding: 14px 16px;\n}\n\n.elements-no-matches-title {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n.elements-no-matches p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.6;\n  color: #4b5563;\n}\n\n/* El careo del zoom, por renglones en vez de un párrafo pegado */\n.elements-diff-row {\n  display: flex;\n  gap: 10px;\n  padding: 5px 0;\n  align-items: baseline;\n}\n\n.elements-diff-row + .elements-diff-row { border-top: 1px solid #f0f1f3; }\n\n.elements-diff-campo {\n  flex: 0 0 76px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: #8a94a0;\n}\n\n.elements-diff-row.campo-coincide .elements-diff-campo { color: #1e7e4f; }\n.elements-diff-row.campo-difiere .elements-diff-campo { color: #9a6b00; }\n.elements-diff-row.campo-veredicto .elements-diff-campo { color: #2c3e50; }\n\n.elements-diff-valor { flex: 1; }\n\n@media (max-width: 760px) {\n  .elements-diff-row { flex-direction: column; gap: 2px; }\n  .elements-diff-campo { flex: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
